import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/services/services.index';

@Component({
  selector: 'app-line',
  templateUrl: './line.component.html',
  styleUrls: ['./line.component.css']
})
export class LineComponent implements OnInit {

  courses:any = [];
  coupons:any = [];
  
  constructor(
    public router: Router,
    private settings: SettingsService,
  ) { }
  
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.courses = this.settings['local']['courses'];
    this.coupons = this.settings['local']['coupons'];

    this.settings['local']['page'] = 'aprendizaje';
    this.settings.saveSettings();
  }

  goToPage(param:any){
    this.settings['local']['course'] = param;
    this.settings.saveSettings();
    this.router.navigate(['/curso']);
  };

  goToCourse(param:any) {
    let url;
    if (!param['free']) {
      if (param['cupon']) {
        url = param['url'] + param['cupon'];
      } else if (this.coupons[0]) {
        url = param['url'] + this.coupons[0];
      } else if (param['cuponDefault']) {
        url = param['url'] + param['cuponDefault'];
      } 
    } else {
      url = param['urlRef']
    }

    window.open(url, '_blank');
  };

}
